// extracted by mini-css-extract-plugin
module.exports =  {"video":"ccfda6eb9f--video--HDkeC"};